import { ref, computed } from 'vue'
import { useProfileSteps } from './useProfileSteps.js'
import { useEventSteps } from './useEventSteps.js'
import { useLoginSteps } from './useLoginSteps.js'

const stepIndex = ref(0)

export const useAuthSteps = ({ MODES, mode, userValues, toggleAuthModal, fetchProfileInfo }) => {
    const { profileRegisterSteps } = useProfileSteps()
    const { eventRegisterSteps } = useEventSteps()
    const { loginSteps } = useLoginSteps()

    const authSteps = computed(() => {
        switch (mode.value) {
            case MODES.Login:
                return loginSteps.value
            case MODES.ProfileRegister:
                return profileRegisterSteps.value
            case MODES.EventRegister:
                return eventRegisterSteps.value
            default:
                return []
        }
    })

    ;(async () => {
        await _showAuthStepIfRedirected()
    })()

    function updateProfileOrEventSteps(profileStepId, eventStepId, profileOnly = false) {
        if (profileOnly) {
            updateStepIndex(profileRegisterSteps, profileStepId)
        } else {
            if (mode.value === MODES.ProfileRegister) {
                updateStepIndex(profileRegisterSteps, profileStepId)
            } else if (mode.value === MODES.EventRegister) {
                updateStepIndex(eventRegisterSteps, eventStepId)
            }
        }
    }
    async function _showAuthStepIfRedirected() {
        const authModal = localStorage.getItem('auth-modal')
        const role = localStorage.getItem('role')
        const registerMode =
            localStorage.getItem('register-mode') === MODES.Login.toString()
                ? MODES.ProfileRegister.toString()
                : localStorage.getItem('register-mode')

        localStorage.removeItem('auth-modal')
        localStorage.removeItem('role')
        localStorage.removeItem('register-mode')

        if (authModal && role && registerMode) {
            await fetchProfileInfo()

            if (
                (authModal === 'auth' &&
                    userValues.value.email &&
                    !userValues.value.artistSlug &&
                    !userValues.value.venueSlug) ||
                authModal === 'link'
            ) {
                toggleAuthModal(true)

                mode.value = Object.values(MODES).find((m) => m.toString() === registerMode)

                switch (authModal) {
                    case 'auth':
                        updateStepIndex(profileRegisterSteps, 'profile-register')
                        break
                    case 'link':
                        if (mode.value === MODES.ProfileRegister) {
                            updateStepIndex(profileRegisterSteps, `${role}-register-one`)
                        } else {
                            updateStepIndex(eventRegisterSteps, `${role}-register-one`)
                        }
                        break
                    default:
                        break
                }
            }
        }
    }
    function updateStepIndex(stepArr, identifier) {
        stepIndex.value = stepArr.value.indexOf(stepArr.value.find((step) => step.identifier === identifier))
    }

    return {
        stepIndex,
        loginSteps,
        profileRegisterSteps,
        eventRegisterSteps,
        authSteps,
        updateStepIndex,
        updateProfileOrEventSteps
    }
}
